import { Component, OnDestroy, OnInit } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { Observable, Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { SnackbarService } from "src/app/core/service/snackbar.service";
import { ProfileService } from "../../services/profile.service";

@Component({
    selector: "app-profile-change-email",
    templateUrl: "./profile-change-email.component.html",
    styleUrls: ["./profile-change-email.component.scss"]
})
export class ProfileChangeEmailComponent implements OnInit, OnDestroy {
    private userSubscription: Subscription;

    public loading$: Observable<boolean>;
    public editMode: boolean;
    public formGroup: UntypedFormGroup;

    public emailAtual: string;

    constructor(
        private translate: TranslateService,
        private profileService: ProfileService,
        private authService: AuthService,
        private snackBar: SnackbarService
    ) {
        this.editMode = false;
        this.emailAtual = "";

        this.loading$ = this.profileService.getLoadingAsync();

        this.userSubscription = this.profileService.getUserAsync().subscribe((user) => {
            if (user) {
                this.emailAtual = user.email;
            }
        });
    }

    ngOnInit(): void {
        this.profileService.getLoggedUser();

        this.formGroup = new UntypedFormGroup({
            novoEmail: new UntypedFormControl({ value: "", disabled: !this.editMode }, Validators.required)
        });

        this.formGroup.markAllAsTouched();
    }

    ngOnDestroy(): void {
        this.userSubscription.unsubscribe();
        this.profileService.clear();
    }

    toggleEdition(): void {
        if (this.editMode) {
            if (!this.formGroup.valid) {
                this.translate.get("MESSAGES.REQUIRED").subscribe((res) => {
                    this.snackBar.showMessage(res);
                });
                return;
            }

            this.formGroup.controls["novoEmail"].disable();

            this.save();
        } else {
            this.formGroup.controls["novoEmail"].enable();
        }

        this.editMode = !this.editMode;
    }

    private save(): void {
        const novoEmail: string = this.formGroup.value.novoEmail;
        this.profileService.requestUserEmailUpdate(novoEmail);
    }
}
